import { sign } from "crypto";

// English translations for auth
export const enAuthTranslations = {
	auth: {
		welcomeBack: 'Welcome Back',
		loginSubtitle: 'Sign in to manage your restaurant menu',
		email: 'Email',
		emailPlaceholder: 'your@email.com',
		password: 'Password',
		passwordPlaceholder: '••••••••',
		rememberMe: 'Remember me',
		forgotPassword: 'Forgot password?',
		login: 'Sign In',
		loginWithGoogle: 'Sign in with Google',
		noAccount: "Don't have an account?",
		signUp: 'Sign up',
		invalidCredentials: 'Invalid email or password',
		// Registration
		createAccount: 'Create Account',
		registerSubtitle: 'Get started with your restaurant menu',
		name: 'Full Name',
		namePlaceholder: 'John Doe',
		confirmPassword: 'Confirm Password',
		confirmPasswordPlaceholder: '••••••••',
		agreement: 'I agree to the',
		termsOfService: 'Terms of Service',
		privacyPolicy: 'Privacy Policy',
		alreadyHaveAccount: 'Already have an account?',
		// Password reset
		resetPassword: 'Reset Password',
		resetPasswordSubtitle: 'Enter your email to reset your password',
		sendResetLink: 'Send Reset Link',
		backToLogin: 'Back to login',
		resetPasswordSuccess: 'Check your email for reset instructions',
		// Validation messages
		required: 'This field is required',
		invalidEmail: 'Please enter a valid email',
		passwordLength: 'Password must be at least 8 characters',
		passwordsDontMatch: 'Passwords do not match',
		acceptTerms: 'You must accept the terms and conditions',
		signin: 'Sign In to your account'
	}
};
